module["exports"] = [
  "North",
  "East",
  "South",
  "West",
  "Northeast",
  "Northwest",
  "Southeast",
  "Southwest"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/address/direction.js
// module id = 2563
// module chunks = 1610